import React from "react";
import I18n from "i18n.js.erb";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import DigitalCaseOverlay from "./DigitalCaseOverlay";

const CASE_SIZE = 'sm';
const CASE_WIDTH = 177.5;
const CASE_HEIGHT = 300;

const SMALL_CASE_SIZE = 'xsm';
const SMALL_CASE_WIDTH = 142;
const SMALL_CASE_HEIGHT = 240;

const ExpoTotemCell = ({
  grading,
  blueprintImage,
  label,
  cellState,
  serialNumber,
  imageSize = 'shrinked_medium',
  cellSize = 'large',
}) => {
  const isSmall = cellSize === 'small';
  const caseSize = isSmall ? SMALL_CASE_SIZE : CASE_SIZE;
  const caseWidth = isSmall ? SMALL_CASE_WIDTH : CASE_WIDTH;
  const caseHeight = isSmall ? SMALL_CASE_HEIGHT : CASE_HEIGHT;
  const logoWidth = isSmall ? 24 : 40;

  const errorOverlay = cellState === 'error' ? (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="tooltip-cell-error">
          {I18n.t('js.loopDashboard.cellErrorTooltip')}
        </Tooltip>
      }
    >
      <div className="loop-cell-error-overlay" />
    </OverlayTrigger>
  ) : null;

  if (!grading) {
    return (
      <div
        className="loop-cell-empty d-flex justify-content-center align-items-center position-relative"
        style={{ width: `${caseWidth}px`, height: `${caseHeight}px` }}
      >
        <img src="/images/icons/black/aigrading_logo.svg" alt="" width={logoWidth} style={{ opacity: 0.15 }} />
        {errorOverlay}
      </div>
    );
  }

  // I sigillati diversi dalle bustine (box e simili) non hanno etichetta ne' sleeve: niente gemello
  // digitale da ricreare, si mostra solo il prodotto nello stesso ingombro della cella
  const category = (grading.category_name || 'singles').toLowerCase();
  if (!['singles', 'booster pack'].includes(category)) {
    return (
      <div className="loop-cell-sealed position-relative" style={{ width: `${caseWidth}px`, height: `${caseHeight}px` }}>
        <ShowBlueprintImageFrontImage
          size={imageSize}
          blueprintImage={blueprintImage}
          cursor="default"
          containerCssClassList="d-flex justify-content-center position-relative text-center"
        />
        {errorOverlay}
      </div>
    );
  }

  return (
    <div className="position-relative">
      <DigitalCaseOverlay
        labelLines={[label?.line_1, label?.line_2, label?.line_3, label?.line_4]}
        titleLine={label?.line_5}
        serialNumber={serialNumber}
        grading={grading}
        size={caseSize}
      >
        <ShowBlueprintImageFrontImage
          size={imageSize}
          blueprintImage={blueprintImage}
          cursor="default"
          containerCssClassList="d-flex justify-content-center position-relative text-center"
        />
      </DigitalCaseOverlay>
      {errorOverlay}
    </div>
  );
};

export default ExpoTotemCell;
